import * as React from 'react';

import { RouteProps } from 'react-router-dom';

import { Error } from './components/error/Error';
import { AdminLayout } from './layouts/admin-layout';
import FrontLayout from './layouts/front-layout/FrontLayout';
import AdminDashboard from './pages/admin/admin-dashboard/AdminDashboard';
import ArticleForm from './pages/admin/articles-form/ArticleForm';
import Articles from './pages/admin/articles/Articles';
import Categories from './pages/admin/categories/Categories';
import Countries from './pages/admin/countries/Countries';
import Hashtags from './pages/admin/hashtags/Hashtags';
import Menu from './pages/admin/menu/Menu';
import { SettingsPage } from './pages/admin/settings';
import UserForm from './pages/admin/user-form/UserForm';
import Users from './pages/admin/users/Users';
import Content from './pages/content/Content';
import { Login } from './pages/login/Login';
import Logout from './pages/logout/Logout';
import PeopleDirectory from './pages/people-directory/PeopleDirectory';
import { Preview } from './pages/preview/Preview';
import SearchResults from './pages/search-results/SearchResults';

interface ILayoutProps {
  search?: boolean;
}

export interface IRoute extends RouteProps {
  layout: React.ComponentClass;
  layoutProps?: ILayoutProps;
}

export default [
  {
    component: Login,
    path: '/:locale(\\S{2})?/login',
  },
  {
    component: Logout,
    path: '/:locale(\\S{2})?/logout',
  },
  {
    component: PeopleDirectory,
    exact: true,
    layout: FrontLayout,
    layoutProps: {
      search: false,
    },
    path: '/:locale(\\S{2})?/people',
  },
  {
    component: AdminDashboard,
    exact: true,
    layout: AdminLayout,
    path: '/admin',
  },
  {
    component: Articles,
    exact: true,
    layout: AdminLayout,
    path: '/admin/articles',
  },
  {
    component: ArticleForm,
    exact: true,
    layout: AdminLayout,
    path: '/admin/articles/:id',
  },
  {
    component: Hashtags,
    exact: true,
    layout: AdminLayout,
    path: '/admin/hashtags/:id?',
  },
  {
    component: Categories,
    exact: true,
    layout: AdminLayout,
    path: '/admin/categories/:id?',
  },
  {
    component: Menu,
    exact: true,
    layout: AdminLayout,
    path: '/admin/menu/:id?',
  },
  {
    component: Users,
    exact: true,
    layout: AdminLayout,
    path: '/admin/users',
  },
  {
    component: UserForm,
    exact: true,
    layout: AdminLayout,
    path: '/admin/users/:id',
  },
  {
    component: Countries,
    exact: true,
    layout: AdminLayout,
    path: '/admin/countries/:id?',
  },
  {
    component: SettingsPage,
    exact: true,
    layout: AdminLayout,
    path: '/admin/settings/:id?',
  },
  {
    component: () => <Error>Page not found</Error>,
    layout: AdminLayout,
    path: '/admin',
  },
  {
    component: SearchResults,
    exact: true,
    layout: FrontLayout,
    path: '/:locale(\\S{2})?/search',
  },
  {
    component: Preview,
    exact: true,
    layout: FrontLayout,
    path: '/:locale(\\S{2})?/preview',
  },
  {
    component: Content,
    exact: true,
    layout: FrontLayout,
    path: '/:locale(\\S{2})?/:id1?/:id2?/:id3?/:id4?/:id5?/:id6?/:id7?',
  },
] as IRoute[];
